import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from 'react-router-dom';
import type { StationLink } from '../../types/place';
import { palette } from '../../themes/theme';

interface StationLinksProps {
  links: StationLink[];
  direction: string;
}

const isExternalUrl = (url: string) => /^https?:\/\//.test(url);

const StationLinks: React.FC<StationLinksProps> = ({ links, direction }) => {
  const navigate = useNavigate();

  if (!links || links.length === 0) return null;

  const linkStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    color: palette.primary.blue,
    fontSize: '15px',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    textDecoration: 'underline',
    textUnderlineOffset: '3px',
    cursor: 'pointer',
    '&:hover': { color: palette.primary.dark },
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2, direction }}>
      {links.map((link, index) =>
        isExternalUrl(link.url) ? (
          <Typography
            key={index}
            component="a"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={linkStyle}
          >
            {link.text}
            <OpenInNewIcon sx={{ fontSize: '16px' }} />
          </Typography>
        ) : (
          <Typography
            key={index}
            component="span"
            onClick={() => navigate(link.url)}
            sx={linkStyle}
          >
            {link.text}
          </Typography>
        )
      )}
    </Box>
  );
};

export default StationLinks;
